<template>
  <section class="signin-screen">
    <el-col :md="12" :lg="10" :sm="24" :xs="24" :xl="10" class="login-screens-right">
      <section class="signin-form">
        <AuthNutronMobileLogo />
        <h3 class="form-title">Sign In</h3>
        <p class="error global-error"
                v-if="getErrors && getErrors['error']"
        >{{ this.getErrors['error'] }}</p>
        <el-form ref="form" :model="sign_in" class="login-forms" @keyup.enter.native="onSubmit">
          <el-row :gutter="30">
            <el-col :md="24">
              <el-form-item label="Email Address">
                <el-input v-model="sign_in.username" placeholder="User Name" autofocus></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['username']"
                >{{ this.getErrors['username'] }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item class="mb-0" label="Password">
                <el-input v-model="sign_in.password" placeholder="Password" show-password></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['password']"
                >{{ this.getErrors['password'] }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <div class="forgot-password">
                <router-link class="text-white" to="/forgot-password">Forgot Password ?</router-link>
              </div>
            </el-col>
            <el-col :md="24">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSubmit"
                  :loading="loading"
                  class="btn submit-btn mt-0"
                >Sign In</el-button>
                <div class="form-navigation sign-up-link">
                  <router-link class="pt-15" :to="{ name: 'signup' }">
                    Don't have an
                    account ?
                  </router-link>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="mobile-copyright hidden-md-and-up">
          <el-row>
            <el-col :xl="24">
              <p>
                Copyright © 2019
              </p>
            </el-col>
            <el-col :xl="24">
              <p>
                Powered by
                <a href="https://orotron.com/" target="_blank">OROTRON</a>
              </p>
            </el-col>
          </el-row>
        </div>
      </section>
    </el-col>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import AuthenticationLayout from "../../layouts/AuthenticationLayout.vue";
import AuthNutronMobileLogo from "./AuthNutronMobileLogo";

export default {
  components: {AuthNutronMobileLogo},
  data() {
    return {
      loading: false,
      sign_in: {
        username: "",
        password: ""
      }
    };
  },
  created() {
    this.$emit("update:layout", AuthenticationLayout);
    this.$root.$emit('closenav', false);
  },
  mounted() {
    this.$store.dispatch("errors/clear", null, { root: true });
  },
  computed: {
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getAuthenticationDetails",
      "getErrorMessage"
    ]),
    ...mapGetters("errors", ["getErrors", "getMessage"])
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      await this.$store.dispatch("auth/sign_in", this.sign_in);
      this.loading = false;
      if (this.getAuthenticatedUser) {
        this.$message.success(this.getMessage);
        await this.$store.dispatch("errors/clear");
        await this.$router.push({name: "home"});
      }
    }
  }
};
</script>

<style scoped lang="scss">
.sign-up-link {
  a {
    color: #ffffff !important;
  }
}

.signin-other {
  margin-top: 30px;

  .signib-other-title {
    color: #fff;
    text-align: center;
    position: relative;
    overflow: hidden;
    text-transform: uppercase;
    font-size: 16px;

    &::after {
      content: "";
      position: absolute;
      width: 45%;
      top: 40%;
      transform: translateY(-50%);
      height: 1px;
      background: #fff;
      left: 0;
    }

    &::before {
      content: "";
      position: absolute;
      width: 45%;
      right: 0;
      top: 40%;
      transform: translateY(-50%);
      height: 1px;
      background: #fff;
    }
  }

  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;

    li:not(:last-child) {
      margin-right: 15px;
    }

    li {
      img {
        width: 15px;
      }

      p {
        color: #fff;
        font-size: 13px;
        padding-bottom: 2px;
      }
    }
  }
}
</style>
